// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"85a92ce5","52":"c5f47f42","313":"96ea1094","322":"697e73cb","422":"8017f441","558":"fde03d96","574":"1d844fc1","654":"b8679ca0","837":"57a7cb7d"}[chunkId] + ".chunk.js";
};